export default {
  'clubs.detailSingin': 'Thông tin đăng nhập',
  'clubs.status': 'Trạng thái hoạt động',
  'clubs.status.active': 'Đang hoạt động',
  'clubs.status.not-active': 'Ngưng hoạt động',
  'clubs.non-delete.title': 'Không thể xóa',
  'clubs.non-delete.content': 'Không thể xóa Liên Đoàn đang hoạt động',
  'clubs.delete.title': 'Xóa Liên Đoàn',
  'clubs.delete.content': 'Bạn có muốn xóa Liên Đoàn đã chọn',
  'clubs.account-infomation': 'Thông tin đăng nhập',

  'clubs.name': 'Liên Đoàn',
  'clubs.listOfClubs': 'Danh sách Liên Đoàn',
  'clubs.add': 'Thêm Liên Đoàn mới',
  'clubs.code': 'Mã Liên Đoàn',
  'clubs.enterpriseName': 'Tên đơn vị',
  'clubs.quantity': 'Chi Đoàn (Số lượng)',
  'clubs.provinceCode': 'Địa chỉ',
  'clubs.districtCode': 'Quận / Huyện',
  'clubs.communeCode': 'Phường / Xã',
  'clubs.placeholder.provinceCode': 'Nhập Tỉnh / Thành phố',
  'clubs.placeholder.districtCode': 'Nhập Quận /Huyện',
  'clubs.placeholder.communeCode': 'Nhập Phường / Xã',
  'clubs.placeholder.address': 'Địa chỉ chi tiết',
  'clubs.road': 'Đường',
  'clubs.emailAddress': 'Email',
  'clubs.headOfficeAddress': 'Địa chỉ',
  'clubs.status.param':
    '{status,select, 1 {Đang hoạt động} 2 {Dừng hoạt động} other {Không xác định}}',
  'clubs.action': 'Hành động',
  'clubs.info': 'Chi tiết',
  'clubs.edit': 'Cập nhật',
  'clubs.represents': 'Phụ trách Đoàn',
  'clubs.member': 'Danh sách Đoàn viên',
  'clubs.table.quantity': 'Số lượng Đoàn viên',
  'clubs.view': 'Chi tiết Liên Đoàn',
  'clubs.infomation': 'Thông tin Liên Đoàn',
  'clubs.countOfMember': 'Đoàn viên (Số lượng)',

  'clubs.list-represents': 'Phụ trách Đoàn',
  'represents.code': 'Mã',
  'represents.name': 'Họ và tên',
  'represents.gender': 'Giới tính',
  'represents.gender.male': 'Nam',
  'represents.gender.female': 'Nữ',
  'represents.dayOfBirth': 'Ngày sinh',
  'represents.phoneNumber': 'Số điện thoại',
  'clubs.label.emailAddress': 'Email',
  'represents.add': 'Thêm Phụ trách Đoàn',
  'represents.placeholder.dayOfBirth': 'Nhập ngày sinh',
  'represents.personal-infomation': 'Thông tin cá nhân',
  'represents.about-clubs': 'Về Đoàn',
  'represents.title': 'Chức danh',
  'represents.prorogues': 'Nhiệm kỳ',
  'represents.emailAddress': 'Email',
  'represents.placeholder.prorogues': 'Nhập nhiệm kỳ',
  'represents.action': 'Hành động',
  'represents.info': 'Chi tiết',
  'represents.edit': 'Cập nhật',
  'represents.view': 'Chi tiết Phụ trách Đoàn',
  'represents.delete.title': 'Xóa Phụ trách Đoàn',
  'represents.delete.content': 'Bạn có muốn xóa Phụ trách Đoàn đã chọn',

  'clubs.member.heading': 'Danh sách Đoàn viên',
  'clubs.list-members': 'Đoàn viên',
  'clubs.member.add': 'Thêm Đoàn viên',
  'clubs.member.title': 'Đoàn viên',
  'member.code': 'Mã',
  'member.idCard': 'Mã thẻ',
  'member.name': 'Họ và tên',
  'member.grade': 'Khối lớp',
  'member.workUnit': 'Chi Đoàn',
  'member.phoneNumber': 'Số điện thoại',
  'member.avatar': 'Ảnh đại diện',
  'member.personal-infomation': 'Thông tin cá nhân',
  'member.placeholder.grade': 'Chọn khối lớp',
  'leaderInfo.name': 'Họ và tên',
  'leaderInfo.position': 'Quan hệ',
  'leaderInfo.emailAddress': 'Email',
  'member.leaderInfo': 'Thông tin người đại diện',
  'member.info': 'Chi tiết',
  'member.edit': 'Cập nhật',
  'member.action': 'Hành động',
  'clubs.member.edit': 'Cập nhật Đoàn viên',
  'member.non-delete.title': 'Không thể xóa',
  'member.non-delete.content': 'Không thể xóa Đoàn viên đang hoạt động',
  'member.delete.title': 'Xóa Đoàn viên',
  'member.delete.content': 'Bạn có muốn xóa Đoàn viên đã chọn',
  'clubs.member.view': 'Chi tiết Đoàn viên',
  'member.clubs': 'Liên Đoàn',

  // update on 09/10/2023
  'clubs.searhModal.title': 'Tìm kiếm đoàn viên',
  'clubs.search-label': 'Từ khóa',
  'clubs.search': 'Tìm',
  'clubs.result-search': 'Không tìm thấy đoàn viên.',
  'clubs.result-search-page': 'Kết quả tìm kiếm',
  'clubs.result-search-page.name': 'Tên đoàn viên',
  'clubs.type': 'Loại đoàn viên',
  'clubs.memberPersonal': 'Đoàn viên',
  'clubs.club-represent': 'Phụ trách đoàn',
  'clubs.meritBadges': 'Thành tích',
  'clubs.rewards': 'Giấy khen',
};
